<ng-container *transloco="let t">
    <form
        [formGroup]="disclosure"
        #ngForm="ngForm"
        fxLayout="column"
        (ngSubmit)="onSubmit($event)"
    >
        <div *ngIf="releaseOfInformationIds || dataSharingAgreed">
            <h3>
                {{ t("application.disclosure.data-sharing") }}
            </h3>
            <app-multi-selection-control
                *ngIf="
                    releaseOfInformationSelections$
                        | async as releaseOfInformationSelections
                "
                [formGroup]="disclosure"
                [selections]="releaseOfInformationSelections"
                [control]="releaseOfInformationIds"
                formControlName="releaseOfInformationIds"
                [label]="t('application.disclosure.release-of-information')"
                [requiredMessage]="
                    t('shared.error.required.release-of-information')
                "
                [formSubmitted]="ngForm.submitted"
            ></app-multi-selection-control>

            <div
                *ngIf="dataSharingAgreed"
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div fxFlex="100" fxFlex.xs="100" fxFlexFill>
                    <mat-checkbox
                        id="data-sharing-aggreed"
                        class="checkbox-signature full-width"
                        formControlName="dataSharingAgreed"
                    >
                        {{ t("application.disclosure.data-sharing-approval") }}
                    </mat-checkbox>
                    <mat-error
                        *ngIf="
                            dataSharingAgreed?.hasError('required') &&
                            dataSharingAgreed?.touched
                        "
                    >
                        {{ t("shared.error.required.data-sharing-aggreed") }}
                    </mat-error>
                </div>
            </div>
            <br />
            <mat-divider></mat-divider>
        </div>

        <h3 *ngIf="studentFirstName || studentLastName">
            {{ t("application.disclosure.student-signature") }}
        </h3>
        <div
            *ngIf="studentFirstName || studentLastName"
            fxLayout="row"
            fxLayout.xs="column"
            fxLayoutAlign="start center"
        >
            <div
                *ngIf="studentFirstName"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlex.sm="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{
                        t("shared.field.legal-first-name")
                    }}</mat-label>
                    <input
                        matInput
                        formControlName="studentFirstName"
                        [autocomplete]="'studentFirstName' | autocomplete"
                        maxlength="200"
                        [required]="studentFirstName.hasError('required')"
                    />
                    <mat-error *ngIf="studentFirstName?.hasError('required')">{{
                        t("shared.error.required.legal-first-name")
                    }}</mat-error>
                </mat-form-field>
            </div>
            <div
                *ngIf="studentLastName"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlex.sm="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{ t("shared.field.last-name") }}</mat-label>
                    <input
                        matInput
                        formControlName="studentLastName"
                        [autocomplete]="'studentLastName' | autocomplete"
                        maxlength="200"
                        [required]="studentLastName.hasError('required')"
                    />
                    <mat-error *ngIf="studentLastName?.hasError('required')">{{
                        t("shared.error.required.last-name")
                    }}</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div
            *ngIf="studentSignatureDate"
            fxLayout="row"
            fxLayout.xs="column"
            fxLayoutAlign="start center"
        >
            <div
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlex.sm="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{ t("shared.field.currentDate") }}</mat-label>
                    <input
                        matInput
                        [matDatepicker]="studentSignatureDatePicker"
                        formControlName="studentSignatureDate"
                        maxlength="10"
                        [required]="studentSignatureDate.hasError('required')"
                    />
                    <mat-error
                        *ngIf="studentSignatureDate?.hasError('required')"
                        >{{ t("shared.error.required.currentDate") }}</mat-error
                    >
                    <mat-error
                        *ngIf="studentSignatureDate?.hasError('invalidDate')"
                        >{{ t("shared.error.signatureDate") }}
                    </mat-error>
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="studentSignatureDatePicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                        #studentSignatureDatePicker
                    ></mat-datepicker>
                    <mat-hint>MM/DD/YYYY</mat-hint>
                </mat-form-field>
            </div>
        </div>
        <div
            *ngIf="studentHasSigned"
            class="flyout-container"
            fxLayout="row"
            fxLayout.xs="column"
            fxLayoutAlign="start center"
        >
            <p
                class="sub-title"
                fxFlex="100"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlex.sm="100"
                fxFlexFill
            >
                {{ t("application.disclosure.student-signature-label") }}
                <mat-card
                    appearance="outlined"
                    class="sub-title-tooltip height-auto"
                >
                    <h2>
                        {{
                            t(
                                "application.disclosure.student-signature-acknowledgement.header"
                            )
                        }}
                    </h2>
                    <p>
                        {{
                            t(
                                "application.disclosure.student-signature-acknowledgement.text"
                            )
                        }}
                    </p>
                </mat-card>
            </p>
        </div>
        <div
            *ngIf="studentHasSigned"
            fxLayout="row"
            fxLayout.xs="column"
            fxLayoutAlign="start center"
        >
            <div fxFlex="45" fxFlex.xs="100" fxFlexFill>
                <mat-checkbox
                    id="student-signature"
                    class="checkbox-signature"
                    formControlName="studentHasSigned"
                >
                    {{ t("application.disclosure.signature-approval") }}
                </mat-checkbox>
                <mat-error
                    *ngIf="
                        studentHasSigned?.hasError('required') &&
                        studentHasSigned?.touched
                    "
                >
                    {{ t("shared.error.required.student-has-signed") }}
                </mat-error>
            </div>
        </div>
        <br />
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
            <div fxFlex="100" fxFlex.xs="100" fxFlexFill>
                <mat-label *ngIf="studentHasSigned?.value" class="signature">{{
                    studentFirstName?.value | fullName : studentLastName?.value
                }}</mat-label>
            </div>
        </div>

        <mat-divider></mat-divider>

        <div *ngIf="isParentSignatureRequired">
            <h3>
                {{ t("application.disclosure.parent-signature") }}
            </h3>
            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="50"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlex.sm="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-label>{{
                            t("shared.field.legal-first-name")
                        }}</mat-label>
                        <input
                            matInput
                            formControlName="parentFirstName"
                            [autocomplete]="'parentFirstName' | autocomplete"
                            maxlength="200"
                            [required]="
                                parentFirstName?.hasError('required') ?? false
                            "
                        />
                        <mat-error
                            *ngIf="parentFirstName?.hasError('required')"
                            >{{
                                t("shared.error.required.legal-first-name")
                            }}</mat-error
                        >
                    </mat-form-field>
                </div>
                <div
                    fxFlex="50"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlex.sm="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-label>{{ t("shared.field.last-name") }}</mat-label>
                        <input
                            matInput
                            formControlName="parentLastName"
                            [autocomplete]="'parentLastName' | autocomplete"
                            maxlength="200"
                            [required]="
                                parentLastName?.hasError('required') ?? false
                            "
                        />
                        <mat-error
                            *ngIf="parentLastName?.hasError('required')"
                            >{{
                                t("shared.error.required.last-name")
                            }}</mat-error
                        >
                    </mat-form-field>
                </div>
            </div>
            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="50"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlex.sm="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-label>{{
                            t("shared.field.currentDate")
                        }}</mat-label>
                        <input
                            matInput
                            [matDatepicker]="parentSignatureDatePicker"
                            formControlName="parentSignatureDate"
                            maxlength="10"
                            [required]="
                                parentSignatureDate?.hasError('required') ??
                                false
                            "
                        />
                        <mat-error
                            *ngIf="parentSignatureDate?.hasError('required')"
                            >{{
                                t("shared.error.required.currentDate")
                            }}</mat-error
                        >
                        <mat-error
                            *ngIf="parentSignatureDate?.hasError('invalidDate')"
                            >{{ t("shared.error.signatureDate") }}
                        </mat-error>
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="parentSignatureDatePicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker
                            #parentSignatureDatePicker
                        ></mat-datepicker>
                        <mat-hint>MM/DD/YYYY</mat-hint>
                    </mat-form-field>
                </div>
            </div>
            <div
                class="flyout-container"
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <p
                    class="sub-title"
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlex.sm="100"
                    fxFlexFill
                >
                    {{ t("application.disclosure.parent-signature-label") }}
                    <mat-card
                        appearance="outlined"
                        class="sub-title-tooltip height-auto"
                    >
                        <h2>
                            {{
                                t(
                                    "application.disclosure.parent-signature-why.header"
                                )
                            }}
                        </h2>
                        <p>
                            {{
                                t(
                                    "application.disclosure.parent-signature-why.text"
                                )
                            }}
                        </p>
                    </mat-card>
                </p>
            </div>
            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div fxFlex="45" fxFlex.xs="100" fxFlexFill>
                    <mat-checkbox
                        id="parent-signature"
                        class="checkbox-signature"
                        formControlName="parentHasSigned"
                    >
                        {{ t("application.disclosure.signature-approval") }}
                    </mat-checkbox>
                    <mat-error
                        *ngIf="
                            parentHasSigned?.hasError('required') &&
                            parentHasSigned?.touched
                        "
                    >
                        {{ t("shared.error.required.parent-has-signed") }}
                    </mat-error>
                </div>
            </div>
            <br />
            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div fxFlex="100" fxFlex.xs="100" fxFlexFill>
                    <mat-label *ngIf="parentHasSigned?.value" class="signature">
                        {{
                            parentFirstName?.value
                                | fullName : parentLastName?.value
                        }}
                    </mat-label>
                </div>
            </div>

            <mat-divider></mat-divider>
        </div>
        <button
            mat-stroked-button
            class="submit"
            type="submit"
            [disabled]="submitting"
        >
            {{ t("application.submit-applications") }}
        </button>
    </form>
</ng-container>
